<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.withdrawal_list") }}  
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-4.col-lg-3.col-3.mb-1
                b-input-group(size="sm")
                  b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                    option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                    option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                    option(value="ticket") {{ $t('ui.ticket') }}
                  template(v-if="['operator'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  template(v-else-if="['member'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                  template(v-if="['ticket'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
              template(v-if="['operator', 'member'].includes(searchType)")
                template(v-if="searchID != ''")
                  .form-group.col-md-4.col-lg-3.col-3.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
                .form-group.col-md-4.col-lg-3.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.status') }}
                    b-form-select(v-model="ticketStatus" :disabled="loading" size="sm" @change="getTicketList")
                      option(value="") {{ $t('ui.all') }}
                      option(value="REJECTED") {{ $t('ui.rejected') }}
                      option(value="REJECTED(ONLOAD)") {{ $t('ui.rejected_onload') }}
                      option(value="PENDING") {{ $t('ui.pending') }}
                      option(value="PROCESSED") {{ $t("ui.processed") }}
                      option(value="PROCESSING") {{ $t("ui.processing") }}
                      option(value="PROCESSED(REJECTED)") {{ $t("ui.processed_rejected") }}
                .form-group.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              .col-md-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th.sortable(width="4%" @click="sortOrder('id')")
                          span(:title="$t('ui.id')") {{ $t('ui.id') }}
                          .float-right 
                            i(:class="changeSortKey('id')")
                        th(width="8%")
                          span(:title="$t('ui.member')") {{ $t('ui.member') }}
                        th.text-right(width="8%")
                          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                        th(width="10%")
                          span(:title="$t('ui.sender_bank')") {{ $t('ui.sender_bank') }}
                        th(width="10%")
                          span(:title="$t('ui.recipient_bank')") {{ $t('ui.recipient_bank') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th(width="6%")
                          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                        th(width="5%")
                          span(:title="$t('ui.review_by')") {{ $t("ui.review_by") }}
                        th(width="5%")
                          span(:title="$t('ui.audit_by')") {{ $t("ui.audit_by") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.audit_time_modified')") {{ $t("ui.audit_time_modified") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                    tbody.clusterize-content
                      tr(v-if="withdrawalList.length == 0")
                        td(colspan="13").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in withdrawalList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.id") {{ item.id }}
                          br
                          span.small.text-info(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter) }}
                        td
                          span.d-block(:title="item.account_id") {{ item.account_id }}
                          span.text-warning(:title="item.operator_id") {{ item.operator_id }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                        td
                          span.small.d-block(:title="item.sender_bank_id") {{ item.sender_bank_id }}
                          span.small.d-block(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
                          span.small.d-block(:title="item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}
                        td
                          span.small(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
                          br
                          span.small(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
                          br
                          span.small(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
                          template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                            br
                            span.small(:title="item.recipient_bank_acc_remark") {{ item.recipient_bank_acc_remark }}
                          template(v-if="['AUD'].includes(getCurrencyCode)")
                            br
                            span.small(:title="item.recipient_bank_acc_remark_2") {{ item.recipient_bank_acc_remark_2 }}
                        td.text-center
                          span(v-if="item.status.trim().toUpperCase() != 'REJECTED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                          template(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_approved == false") 
                            span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                          template(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_approved == true")
                            span(:class="$helpers.badgeClass('PROCESSED')") {{ $t('ui.processed').toUpperCase() }}
                            span.d-block.text-danger ({{ $t('ui.rejected').toUpperCase() }})
                        td.text-center
                          span
                            a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                          span.ml-1(v-if="item.status.trim().toUpperCase() == 'PROCESSED' && isEditAccess")
                            a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectApprovedTicket(item, $event)" :title="$t('ui.reject')")
                          span.ml-1(v-if="item.status.trim().toUpperCase() == 'PROCESSING' && showActionButton('ticketwithdrawalrollbackafffree')")
                            a.fa.fa-undo.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="rollbackProcessingTicket(item, $event)" :title="$t('ui.rollback')")
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td
                          span(:title="item.review_by") {{ item.review_by }}
                        td
                          span(:title="item.audit_by") {{ item.audit_by }}
                        td.text-right
                          span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    ticketdetailfcp(ref="ticketdetailfcp" :ticketDetail="selectedTicket" @failed="handleFailed")
    rejectapprovedticket(ref="rejectapprovedticket" :ticketId="selectedTicketId" @clicked="afterRejectApprovedTicket" @failed="handleFailed")
    rollbackprocessingticket(ref="rollbackprocessingticket" :ticketId="selectedTicketId" @clicked="afterRollbackProcessingTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetailfcp from "@/components/freecreditprovider/ticketDetailFcp.vue";
import rejectapprovedticket from "@/components/freecreditprovider/rejectApprovedTicket.vue";
import rollbackprocessingticket from "@/components/freecreditprovider/rollbackProcessingTicket.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetailfcp,
    rejectapprovedticket,
    rollbackprocessingticket,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    withdrawalList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    ticketStatus: "",
    selectedTicketId: null,
    selectedTicket: null,
    sortKey: "id",
    sortType: "desc",
    ticketId: null,
    searchType: "ticket",
    searchID: "",
    memberID: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {  
      return this.$helpers.showActionButton("e_ticketlistaffiliatefree");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).add(-6, 'days').format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    // this.getTicketList(true);
  },
  methods: {
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    resetInput() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.ticketStatus = "";
      this.ticketId = null;
      this.searchID = "";
      this.memberID = "";
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWithdrawalList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getTicketList(true);
    },
    getTicketDetail: function(e) {
      this.selectedTicket = e;
      this.$refs.ticketdetailfcp.$refs.ticketDetailFcp.show();
    },
    getTicketList() {
      if (this.checkDateRange()) {
        this.getWithdrawalList(true);
      } else {
        this.withdrawalList = [];
        this.totalRow = 0;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListFreeUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.ticket_status = this.ticketStatus
        json.operator_id = this.searchID
        json.account_id = this.memberID
      } else {
        json.ticket_id = this.ticketId
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.totalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    rollbackProcessingTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rollbackprocessingticket.$refs.rollbackProcessingTicket.show();
    },
    afterRollbackProcessingTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.rollback_processing_ticket"), this.$t("message.success"), "success");
    },
    afterRejectApprovedTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.reject_fcp_ticket"), this.$t("message.success"), "success");
    },
    rejectApprovedTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectapprovedticket.$refs.rejectApprovedTicket.show();
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getWithdrawalList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>